import type { RouteObject } from 'react-router-dom'
import { RequirePermission } from '@/auth/RequirePermission'
import { MODULES, permissionCode, type ModuleCode } from '@/lib/permissions'
import ModulePlaceholderPage from '@/pages/ModulePlaceholderPage'
import { MODULE_NAV_ITEMS } from '@/components/layout/nav.config'
import { RequireApproved } from './guards'

/** Modules that already declare their own routes, so they skip the placeholder. */
const IMPLEMENTED_MODULES = new Set<ModuleCode>(['audit_engagements', 'audit_plan'])

/**
 * Routes for the approved sidebar modules that do not have a real page yet.
 *
 * Each is gated by the module's `<module>:view` permission, exactly like the
 * sidebar item that links to it. Modules with a real page (e.g. Audit Plan, see
 * `auditPlan.routes.tsx`) are excluded here and declared separately.
 */
export const moduleRoutes: RouteObject[] = MODULE_NAV_ITEMS.filter(
  (item) => !IMPLEMENTED_MODULES.has(item.module),
).map(({ module, to }) => {
  const definition = MODULES.find((entry) => entry.code === module)
  return {
    path: to.replace(/^\//, ''),
    element: (
      <RequireApproved>
        <RequirePermission permission={permissionCode(module, 'view')}>
          <ModulePlaceholderPage title={definition?.label ?? module} description={definition?.description} />
        </RequirePermission>
      </RequireApproved>
    ),
  }
})
